<template>
  <b-card no-body class="overflow-hidden m-0 p-0">
    <b-row no-gutters>
      <b-col align-self="center">
        <b-card-body class="width350">
          <h6 class="card-title m-0 text-justify"> {{ download.filename || 'dummy file name'}} <br>
            <small> {{ download.mimeType || 'application/text' }} </small> <br>
            <small> {{ progress.total | bytes}} </small>
          </h6>
          <div>
            <base-progress class="progress-xs mt-3 mb-0" type="success" :value="progress.percentage"></base-progress>
            <small>{{ progress.percentage }} %</small> |
            <small>{{ (progress.percentage === 100 ? 0 : progress.speed) | bytes }} / second</small> |
            <template v-if="progress.eta === 0">
              <small>Completed</small>
            </template>
            <template v-else>
              <small>{{ convertToTime(progress.eta) }}</small>
            </template>
          </div>
        </b-card-body>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import fetchProgress from 'fetch-progress';
import moment from 'moment';

export default {
  components: {

  },
  props: {
    download: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      progress: {},
    };
  },
  computed: {
    percentage() {
      if (this.$props.download.progress) {
        return this.$props.download.progress.percentage;
      }
      return 0;
    },
  },
  mounted() {
    const self = this;
    fetch(this.$props.download.signedUrl)
      .then(
        fetchProgress({
          onProgress(progress) {
            self.$props.download.status = 'progress';
            self.progress = {
              total: progress.total,
              transferred: progress.transferred,
              speed: progress.speed,
              eta: progress.eta,
              remaining: progress.remaining,
              percentage: progress.percentage,
            };
          },
          onError(err) {
            console.error(err);
          },
        }),
      )
      .then((r) => r.blob())
      .then((blob) => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = this.$props.download.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        this.$props.download.status = 'done';
      });
  },
  methods: {
    convertToTime(nano) {
      if (nano) return `${moment.duration(nano / 1000000000, 's').humanize()} remaining`;
      return 'waiting for download';
    },
  },
};

</script>

<style scoped lang="scss">
.width350{
  width: 350px;
}
</style>
